<template>
    <div>tbd file upload</div>
</template>

<script>
export default {
    name: 'File',
    props: {
        item: {
            type: Object
        }
    }
};
</script>